import { getContext, setContext } from 'svelte'
import { nanoid } from 'nanoid'

import ElementHandler from './element.js'

export const getId = () => 'i' + nanoid(9)

export const getLayoutComponent = (elementName, composed = true) => {
  const FormTheme = getContext('FormTheme')
  const formGroupLayout = getContext('formGroupLayout')
  const layout =
    composed && formGroupLayout && FormTheme[`${formGroupLayout}Element`] ? `${formGroupLayout}Element` : elementName

  if (!FormTheme) {
    console.error('no form theme defined in context')
    return
  }
  if (!FormTheme[layout]) {
    console.error(`cannot find layout ${layout} in theme`)
    return
  }
  return FormTheme[layout]
}

export const addElement = (...args) => {
  const currentForm = getContext('currentForm')
  if (currentForm) {
    const el = currentForm.registerElement(...args)
    setContext('currentElement', el)
    return el
  } else {
    const el = ElementHandler(...args)
    setContext('currentElement', el)
    return el
  }
}

export const addSubElement = (...args) => {
  const el = ElementHandler(() => {}, ...args)
  setContext('currentSubElement', el)
  return el
}

export const addDataBlock = setData => {
  const currentForm = getContext('currentForm')
  if (currentForm) currentForm.registerDataBlock(setData)
}

export const schemaElements = (schema, reference = '#/properties/') => {
  const elements = []
  for (const p of Object.keys(schema.properties)) {
    //  console.debug('DEBUG', p, schema.properties[p])
    if (schema.properties[p].type === 'object') {
      elements.push({
        name: p,
        type: 'VerticalLayout',
        renderer: 'FormGroup',
        elements: schemaElements(schema.properties[p], reference + p + '/properties/')
      })
    } else {
      elements.push({
        name: p,
        type: 'Control',
        renderer: 'TextField',
        scope: reference + p,
        label: schema.properties[p].title,
        info: schema.properties[p].description
      })
    }
  }
  return elements
}

const Form = ({ validationMode }) => {
  const $ = {
    elements: [],
    dataBlocks: []
  }

  $.unregisterElement = id => {
    $.elements = $.elements.filter(e => e.id !== id)
  }

  $.registerElement = (...args) => {
    const el = ElementHandler(...args)
    el.setHandler('onDestroy', () => $.unregisterElement(el.id))
    el.setValidationMode(validationMode)
    $.elements.push(el)
    return el
  }

  $.registerDataBlock = setData => {
    $.dataBlocks.push({ beforeSubmit: setData })
  }

  $.reset = () => {
    for (const element of $.elements) element.reset()
    return true
  }

  $.submit = async () => {
    let success = true
    for (const element of $.elements) success = (await element.validateValue()) && success
    for (const dataBlock of $.dataBlocks) dataBlock.beforeSubmit()
    // ('success', success)
    return success
  }

  return Object.seal($)
}

export default Form
